define("TavanoTeam.CSExtensions.Checkout.EntryPoint", ["TavanoTeam.CSExtensions.CSCertCaptureExt", "TavanoTeam.CapSciExtensions.CSSearchSpringExt.Footer", "TavanoTeam.CapSciExtensions.CSSearchSpringExt.OrderWizard.Module.Confirmation", "Profile.Model", "SC.Configuration"], function (
  CSCertCaptureCheckout,
  SearchSpringFooterExt,
  SearchSpringConfirmation,

  ProfileModel,

  Configuration
) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      var self = this,
        layout = container.getComponent("Layout");
        
      // Get Environment Component
			this.environment = container.getComponent('Environment'); 

      if (Configuration.get("certCapture.checkout.enable")) {
        CSCertCaptureCheckout.loadCertCaptureCheckout(container);
      }

      if (Configuration.get("searchSpring.enable")) {
        SearchSpringConfirmation.loadSearchSpringConfirmation(container);
        self.loadIntelliSuggestScript(layout);
        SearchSpringFooterExt.loadSearchSpringFooter(container);
      }
    },
    loadIntelliSuggestScript: function (layout) {
      // Exclude from SEO Page Generator
			if (!this.environment.isPageGenerator()) {
        layout.cancelableOn("beforeShowContent", function () {
          if (jQuery('script[src="//cdn.searchspring.net/intellisuggest/is.min.js"]').length == 0) {
            var script = jQuery('<script type="text/javascript" src="//cdn.searchspring.net/intellisuggest/is.min.js"></script>');

            jQuery("body").append(script);
          }
        });
      }
    }
  };
});
